function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 3a2.5 2.5 0 00-2.302 1.523A2 2 0 113 8.437V14.5A2.5 2.5 0 005.5 17h4.1c-.384-.75-.6-1.6-.6-2.5 0-.9.216-1.75.6-2.5H7.5a.5.5 0 010-1h2.757A5.489 5.489 0 0114.5 9c.9 0 1.75.216 2.5.6V5.5A2.5 2.5 0 0014.5 3h-9zM7 8.5a.5.5 0 01.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm-3.5-3a1 1 0 100 2 1 1 0 000-2zm15.5 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
  fill: "#8F90A6"
});

function SvgCustomPropertiesFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCustomPropertiesFilled;